import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useHotkeys } from 'react-hotkeys-hook'
import { publishSaveEvent, SaveEvent, subscribeSaveEvent, unsubscribeSaveEvent } from '@ui/events'

const useSaveShortcut = (onSubmit: (data: unknown) => void) => {
  const { handleSubmit } = useFormContext()

  useHotkeys('ctrl+s', () => {
    publishSaveEvent({ type: 'save' })
  })

  useEffect(() => {
    const saveEvent = () => {
      handleSubmit(data => onSubmit(data))()
    }

    subscribeSaveEvent(saveEvent as unknown as SaveEvent)

    return () => {
      unsubscribeSaveEvent(saveEvent as unknown as SaveEvent)
    }
  }, [handleSubmit, onSubmit])

  return null
}

export default useSaveShortcut
